export default "__VITE_ASSET__cc203194__"